// Helper to auto-detect Wix environment and get endpoints
export function getAutoApiEndpoints(flowAPI) {
  var _flowAPI$environment, _flowAPI$environment2;
  const isViewer = (flowAPI == null || (_flowAPI$environment = flowAPI.environment) == null ? void 0 : _flowAPI$environment.isViewer) === true;
  const isPreview = (flowAPI == null || (_flowAPI$environment2 = flowAPI.environment) == null ? void 0 : _flowAPI$environment2.isPreview) === true;
  return getApiEndpoints({
    isViewer,
    isPreview
  });
}
export function getApiEndpoints(_ref) {
  let isViewer = _ref.isViewer,
    isPreview = _ref.isPreview;
  const isLiveOrPreview = !!isViewer || !!isPreview;
  const BASE_URL = isLiveOrPreview ? '' : 'https://www.wixapis.com';
  const MANAGE_URL = 'https://manage.wix.com';
  const WIX_DATA_HOST = isLiveOrPreview ? '_api/cloud-data/v2' : 'wix-data/v2';
  const ECOM_HOST = 'ecom/v1';
  return {
    BASE_URL,
    MANAGE_URL,
    WIX_DATA_HOST,
    ECOM_HOST,
    Apis: {
      coupons_url: `${BASE_URL}/stores/v2/coupons/query`,
      coupon_url: `${BASE_URL}/stores/v2/coupons`,
      pages_list_url: `${MANAGE_URL}/document-management/v1/pages`,
      fragments_list_url: `${MANAGE_URL}/document-management/v1/fragments?fieldset=FULL`,
      components_list_url: `${MANAGE_URL}/document-management/v2/components/get`,
      data_items_url: `${BASE_URL}/${WIX_DATA_HOST}/items`,
      data_items_query_url: `${BASE_URL}/${WIX_DATA_HOST}/items/query`,
      discounts_query_url: `${BASE_URL}/${ECOM_HOST}/discount-rules/query`,
      discount_query_url: `${BASE_URL}/${ECOM_HOST}/discount-rules`
    }
  };
}
//# sourceMappingURL=apiEndpoints.js.map